import React from 'react';
import IntegrationDocTemplate from '../../../../components/IntegrationDocTemplate';

export default function DocsEtsy() {
  return (
    <IntegrationDocTemplate
      title="Etsy"
      category="Marketplace"
      status="live"
      summary="Etsy Open API v3 — shop info, listings, receipts (orders), inventory. OAuth 2.0 + API key. Rate limits: 10K/day, 10/sec. v2 retiring late 2026."
      prerequisites={[
        'Etsy seller shop in good standing.',
        'API key from developers.etsy.com (5-10 min setup).',
        'User OAuth consent for your shop.',
      ]}
      connectSteps={[
        'Text us "Etsy" with your phone number.',
        'Approve our Etsy app in the OAuth flow (5-10 min).',
        'First sync: shop + active listings + last 30 days of receipts.',
      ]}
      syncedData={[
        { type: 'Listings', detail: 'get_listings, create_listing, update_listing — full attribute set' },
        { type: 'Receipts (orders)', detail: 'get_receipts with min_created filter; line items, shipping' },
        { type: 'Inventory', detail: 'get/update_inventory with variations + offerings' },
        { type: 'Shop info', detail: 'Shop currency, languages, vacation mode' },
      ]}
      agents={[
        { id: 'etsy_listing_agent', name: 'etsy_listing_agent', role: 'SEO-optimized listings + Etsy ranking factors' },
        { id: 'head_ecommerce', name: 'head_ecommerce', role: 'Channel routing director' },
      ]}
      troubleshooting={[
        { question: 'Rate limit exceeded (429)', answer: 'Etsy uses a progressive sliding window — not a fixed 24-hour cycle. Our client backs off. Higher limits require approval from Etsy.' },
        { question: 'Personalization fields rejected', answer: 'Etsy deprecated legacy personalization fields April 9, 2026. Use the new personalization variation pattern.' },
      ]}
      supportLink="/contact"
    />
  );
}
